/* eslint-disable no-undef */
import { post } from '../helper/xhrAPI'
import header from './atoms/header'
import SliderCreator from './atoms/SliderCreator'

header()

document.addEventListener('DOMContentLoaded', e => {
  if (document.querySelector('#validateQuestion')) {
    document.querySelector('#validateQuestion').addEventListener('click', e => {
      e.preventDefault()
      e.target.classList.add('is-loading')
      grecaptcha.ready(function () {
        // eslint-disable-next-line promise/catch-or-return
        grecaptcha.execute(`${e.target.dataset.sitekey}`, { action: 'submit' }).then(function (token) {
          const data = new FormData(document.querySelector('#question-form'))
          data.append('g-recaptcha-response', token)
          const locale = document.querySelector('html').getAttribute('lang')
          post(`/${locale}/make-question`, data, response => {
            createAlert(response.code, response.message, '.question-form', '#question-form')
            if (response.code !== 200) {
              renderErrors(response.errors)
            }
            e.target.classList.remove('is-loading')
          })
        })
      })
    })
  }

  SliderCreator('.three-items-tns', config)
  SliderCreator('.one-item-tns')
})

const createAlert = (type, message, parentClass, referenceElement) => {
  const alert = document.querySelector(`${parentClass} .notification`)
  alert.className = `notification is-light ${type === 200 ? 'is-success' : 'is-danger'}`
  alert.innerHTML = message
  document.querySelector(parentClass).insertBefore(alert, document.querySelector(referenceElement))
  if (type === 200) {
    document.querySelector(referenceElement).classList.add('is-hidden')
  }
}

const renderErrors = errors => {
  Object.keys(errors).forEach(error => {
    const errorHolder = document.querySelector(`.${error}-error`)
    errorHolder.innerHTML = errors[error].errors
  })
}

const config = {
  responsive: {
    '320': {
      'items': 1
    },
    '768': {
      'items': 3
    }
  },
  slideBy: 1
}
